import { GetApiUserSettingsError, GetApiUserSettingsResponse, useGetUserSettings } from '@sit/openapi';
import { UseQueryOptions } from '@tanstack/react-query';

export function useShowIntacctId(
  options?: Omit<
    UseQueryOptions<GetApiUserSettingsResponse, GetApiUserSettingsError, GetApiUserSettingsResponse>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) {
  const { data } = useGetUserSettings(options);
  return data?.showIntacctId ?? false;
}
